/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { tilePattern } from '../room.data';

type TilePatternTypes = {
  pattern: string;
  handlePattern: (arg0: string) => void;
  selectedTileData: object;
  tile: string;
};

const TilePattern = ({ handlePattern, pattern, selectedTileData, tile }: TilePatternTypes) => {
  const rectDisabled = (p: (typeof tilePattern)[number]) => {
    return p.installation === 'quarterTurn' && selectedTileData?.shape?.aspect == 2;
  };

  return (
    <Paper className="TilePattern ZeroTop">
      <Box className="SelectedTileEdit">
        <Typography variant="h6" className="TitleOption">
          <b>Selected Tile</b>
        </Typography>
        <Grid
          container
          direction="row"
          className=""
          columnSpacing={2}
          sx={{ justifyContent: 'left', alignItems: 'flex-start' }}
        >
          <Grid size={{ xs: 3, sm: 3 }}>
            <Box className="SelectedTileEditImage">
              <img src={selectedTileData?.tile || tile} alt="" />
            </Box>
          </Grid>
          <Grid size={{ xs: 9, sm: 9 }}>
            <Box className="SelectedTileEditInfo">
              <Typography variant="body1">
                <b>Shape:</b>
              </Typography>
              <Typography variant="body1">{selectedTileData?.shape?.label}</Typography>
            </Box>
            <Box className="SelectedTileEditInfo">
              <Typography variant="body1">
                <b>Dimensions:</b>
              </Typography>
              <Typography variant="body1">{selectedTileData?.size?.label}</Typography>
            </Box>
            {/* <Button className="SelectedTileEditButton">Edit Tile</Button> */}
          </Grid>
        </Grid>
      </Box>
      <Typography variant="h6" className="TitleOption">
        <b>Select Tile Patterns</b>
      </Typography>
      <Grid
        container
        direction="row"
        className=""
        columnSpacing={2}
        sx={{ justifyContent: 'center', alignItems: 'stretch' }}
      >
        {tilePattern.map((t) => (
          <Grid key={t.installation} size={{ xs: 6, sm: 3 }}>
            <Box
              className={`PatternInfoBtn  
              ${pattern === t.installation ? 'Selected' : ''}
              ${t.disabled || rectDisabled(t) ? 'disabled' : ''}`}
              onClick={() => handlePattern(t.installation)}
            >
              <Box className="PatternImage">
                <img src={t.thumb} alt="" className="PatternIcon" />
                <img src={t.thumbHover} alt="" className="PatternIconHover" />
              </Box>
              <Typography variant="h6">{t.name}</Typography>
              {rectDisabled(t) && (
                <Typography sx={{ fontSize: 12 }}>Not available</Typography>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default TilePattern;
